define([
    '../Util/defaultValue',
    '../Util/defined',
    '../Util/defineProperties',
    '../Util/bind',
    '../Util/encode',
    '../Util/callbackSystem',
    '../System/ColorObj'
], function (
    defaultValue,
    defined,
    defineProperties,
    bind,
    encode,
    callbackSystem,
    ColorObj
) {
    'use strict'

    class GlobalShadow {
        /**
         * @description 阴影颜色。
         * @type {ColorObj}
         * @default #000000FF
         */
        color
        /**
         * @description 是否投射。
         * @type {Boolean}
         * @default true
         */
        bCast
        /**
         * @description 作用范围，此为相对于近截面的比例值。
         * @type {Number}
         * @default 2000.0
         */
        scale
        /**
         * @description 全球阴影对象uuid。
         * @type {String}
         * @readonly
         */
        avatarUuid = null
        /**
         * @description 全球阴影组件uuid。
         * @type {String}
         * @readonly
         */
        componentUuid = null
        /**
         * @description GlobalShadow在CooWasm中类名。
         * @private
         * @readonly
         */
        className = "GlobalShadow"
        static avatarType = "deSMP.Avatar.EnvironmentAvatar"
        static componentType = "AvatarComponent.Environment.GlobalShadowComponent"

        /**
         * 全球阴影。
         * <br /><br />
         * <div align='center'>
         * <img src='images/GlobalShadow.gif' width='900' height='650' /><br />
         * 全球阴影效果图
         * </div>
         * 
         * @demo {@link http://lbs.zjkelan.com/GlobalShadow.html|CooWasm GlobalShadow demo}
         * @alias GlobalShadow
         * @constructor
         *
         * @param {Object} props 包含如下属性的Object：
         * @param {ColorObj} [props.color = ColorObj.fromBytes(0, 0, 0, 255)] 阴影颜色。
         * @param {Boolean} [props.bCast = true] 是否投射阴影。
         * @param {Number} [props.scale = 2000.0] 作用范围，此为相对于近截面的比例值。
         * @param {CallbackBoolean} [callback=null] 加载成功后触发的函数回调。
         * @example
         * var fog = new CooWasm.GlobalShadow({},(state)=>{console.log("load status:" + state)})
         */
        constructor(props, callback) {
            if (!defined(props)) {
                props = {}
                return
            }
            if (defined(props.build) && props.build == true) {
                return
            }
            this.color = defaultValue(props.color, ColorObj.fromBytes(0, 0, 0, 255))
            this.bCast = defaultValue(props.bCast, true)
            this.scale = defaultValue(props.scale, 2000.0)
            //create avatars
            let avatarCategoryName = "deSMP.Avatar.EnvironmentAvatar"
            let shadowCategoryName = "AvatarComponent.Environment.GlobalShadowComponent"
            let categoryNames = ""
            let avatarProps = ""
            let componetProps = ""

            let cProps = ""
            cProps += this.toColorStr("color", this.color, "ShadowColor")
            cProps += this.toStr("bCast", this.bCast, "CastShadow")
            cProps += this.toStr("scale", this.scale, "ShadowScaleFactor")
            componetProps += cProps + "#$%"
            categoryNames += shadowCategoryName + "#$%"
            var idInfo = Element.prototype.NativeAPI.LoadAvatarAndMultiComponent(encode(avatarCategoryName), encode(avatarProps), encode(categoryNames), encode(componetProps), false, this.bVisible, defined(callback))
            if (idInfo != "") {
                var idArray = idInfo.split('#$%')
                this.avatarUuid = idArray[0]
                this.componentUuid = idArray[1]
                callbackSystem.register("LoadAvatarAndComponent", this.avatarUuid, (state) => {
                    this.getProperties()
                    if (defined(callback)) {
                        callback(state)
                    }
                    Element.prototype.Map.globalFogs.push(this)
                })
                //console.log("GlobalShadow avatarUuid:" + this.avatarUuid + " componentUuid:" + this.componentUuid)
            }
        }

        /**
         * <p>
         * 更新单个或者多个对象属性，使之立即生效。
         * </p>
         *
         * @param {Object} [props] 包含如下属性的Object。
         * @param {ColorObj} [props.color] 阴影颜色。
         * @param {Boolean} [props.bCast] 是否投射阴影。
         * @param {Number} [props.scale] 作用范围，此为相对于近截面的比例值。
         * @param {CallbackBoolean} [callback=null] 加载成功后触发的函数回调。
         * @example
         * fog.update({
         *    bVisible:false
         * },(state)=>{console.log("update status:" + state)})
         */
        update(props, callback) {
            let avatarProps = ""
            let componentProps = ""
            let uuids = ""
            if (defined(props)) {
                let cProps = ""
                if (defined(props.color)) {
                    this.color = props.color
                    cProps += "ShadowColor:" + this.color.toHexStr() + "|"
                }
                if (defined(props.bCast)) {
                    this.bCast = props.bCast
                    cProps += "CastShadow:" + String(this.bCast) + "|"
                }
                if (defined(props.scale)) {
                    this.scale = props.scale
                    cProps += "ShadowScaleFactor:" + String(this.scale) + "|"
                }
                componentProps += cProps + "#$%"
                uuids += this.componentUuid + "#$%"
                callbackSystem.register("UpdateAvatarAndMultiComponent", this.avatarUuid, (state) => {
                    if (defined(callback)) {
                        callback(state)
                    }
                })
                Element.prototype.NativeAPI.UpdateAvatarAndMultiComponent(encode(this.avatarUuid), encode(uuids), encode(avatarProps), encode(componentProps), defined(callback))
            }
        }
        toStr(memName, value, key) {
            let result = ""
            if (defined(value)) {
                this[memName] = value
                if (typeof value.toStr === 'function') {
                    result = key + ":" + value.toStr() + "|"
                } else {
                    result = key + ":" + value + "|"
                }
            }
            return result
        }
        toColorStr(memName, value, key) {
            let result = "";
            if (defined(value)) {
                this[memName] = value;
                if (typeof value.toStr === 'function') {
                    result = key + ":" + value.toHexStr() + "|";
                } else {
                    if (typeof value === 'string') {
                        let color = ColorObj.fromCssColorString(value);
                        if (defined(color)) {
                            value = color.toHexStr();
                            this[memName] = value;
                            result = key + ":" + value + "|";
                        } else {
                            console.warn(`Invalid color value: ${value}. Using default value.`);
                        }
                    }
                }
            }
            return result;
        }
        /**
         * 获取全球阴影包含的属性。
         * @returns {Boolean} 是否获取成功。获取成功时，会自动赋值给属性。
         * @example
         * fog.getProperties()
         */
        getProperties() {
            if (!defined(this.avatarUuid) || !defined(this.componentUuid)) {
                console.log("uuid require!")
                return false
            }
            let pAvatarUuid = Element.prototype.NativeAPI.Uuid_New()
            Element.prototype.NativeAPI.Uuid_SetId(pAvatarUuid, encode(this.avatarUuid))
            let pAvatar = Element.prototype.NativeAPI.MapImpl_getAvatar(pAvatarUuid)
            let avatarPropSize = Element.prototype.NativeAPI.Avatar_GetPropertiesSize(pAvatar)
            for (let i = 0; i < avatarPropSize; ++i) {
                let pProp = Element.prototype.NativeAPI.Avatar_GetProperty(pAvatar, i)
                let name = Element.prototype.NativeAPI.Property_GetName(pProp)
                let value = Element.prototype.NativeAPI.Property_GetValue(pProp)
                if (name == "Visible") {
                    if (value == "true" || value == "1") {
                        this.bVisible = true
                    } else {
                        this.bVisible = false
                    }
                }
            }
            let avatarAcSize = Element.prototype.NativeAPI.Avatar_GetAvatarComponentsSize(pAvatar)
            for (let j = 0; j < avatarAcSize; ++j) {
                let pAc = Element.prototype.NativeAPI.Avatar_GetAvatarComponent(pAvatar, j)
                let propSize = Element.prototype.NativeAPI.AvatarComponent_GetPropertiesSize(pAc)
                let pUuid = Element.prototype.NativeAPI.AvatarComponent_GetUuid(pAc)
                let uuid = Element.prototype.NativeAPI.Uuid_GetId(pUuid)
                this.componentUuid = uuid
                for (let z = 0; z < propSize; ++z) {
                    let pProp = Element.prototype.NativeAPI.AvatarComponent_GetProperty(pAc, z)
                    let name = Element.prototype.NativeAPI.Property_GetName(pProp)
                    let value = Element.prototype.NativeAPI.Property_GetValue(pProp)
                    if (name == "CastShadow") {
                        this.bCast = (value == "true" || value == "1")
                    } else if (name == "ShadowScaleFactor") {
                        this.scale = Number(value)
                    } else if (name == "ShadowColor") {
                        this.color = CooWasm.ColorObj.fromCssColorString(value)
                    } else if (name == "ShadowDensity"){
                        this.density = Number(value)
                    }
                }
            }
            Element.prototype.NativeAPI.Avatar_Delete(pAvatar)
            Element.prototype.NativeAPI.Uuid_Delete(pAvatarUuid)
            return true
        }

        /**
         * 从场景中销毁自身。
         * @param {CallbackBoolean} [callback=null] 销毁后触发的函数回调。
         * @returns null 空值。
         * @example
         * fog = fog.destroy((state)=>{console.log("destroy status:" + state)})
         */
        destroy(callback) {
            if (!defined(this.avatarUuid)) {
                console.log("avatarUuid is null!")
                return null
            }
            callbackSystem.register("RemoveAvatar", this.avatarUuid, (state) => {
                if (defined(callback)) {
                    callback(state)
                }
                Element.prototype.Map.globalShadows = Element.prototype.Map.globalShadows.filter(item => item !== this)
                callbackSystem.remove("LoadAvatarAndComponent", this.avatarUuid)
                callbackSystem.remove("UpdateAvatarAndMultiComponent", this.avatarUuid)
                callbackSystem.remove("RemoveAvatar", this.avatarUuid)
                this.avatarUuid = null
                this.componentUuid = null
            })
            Element.prototype.NativeAPI.RemoveAvatar(encode(this.avatarUuid))
            return null
        }
    }
    return GlobalShadow
})